import React from "react";
import Canvas from "../../../components/Canvas";

const HeroSection = () => {
  return (
    <section className="page-hero contact-hero">
      <Canvas />
      <div className="container page-hero-grid">
        <div className="contact-hero-copy">
          <p className="eyebrow">Let’s talk</p>
          <h1>Start a conversation that moves things forward.</h1>
          <p className="hero-copy">
            Whether you’re planning your next career move, building a stronger
            team, or need support, we’ll connect you with the right person.
          </p>
          <div className="actions contact-hero-actions">
            <a className="button button-primary button-lg" href="#contact-form">
              Send us a message
            </a>
            <a
              className="button button-secondary button-lg"
              href="https://calendly.com/hr-lovapextech"
              target="_blank"
              rel="noreferrer"
            >
              Book a call
            </a>
          </div>
          <p className="contact-response">
            <span aria-hidden="true"></span>
            Usually replies within one business day
          </p>
        </div>
        <div className="page-hero-media contact-hero-media">
          <div className="contact-panel">
            <div className="contact-panel-heading">
              <span>Direct contact</span>
              <span className="contact-availability">Available</span>
            </div>

            <a className="contact-method" href="mailto:hello@lovapextech.com">
              <span className="contact-method-icon" aria-hidden="true">
                @
              </span>
              <span>
                <small>General enquiries</small>
                <strong>hello@lovapextech.com</strong>
              </span>
              <span className="contact-method-arrow" aria-hidden="true">
                &rarr;
              </span>
            </a>

            <a className="contact-method" href="mailto:hr@lovapextech.com">
              <span className="contact-method-icon" aria-hidden="true">
                C
              </span>
              <span>
                <small>Career support</small>
                <strong>hr@lovapextech.com</strong>
              </span>
              <span className="contact-method-arrow" aria-hidden="true">
                &rarr;
              </span>
            </a>

            <a className="contact-method" href="tel:+17088401141">
              <span className="contact-method-icon" aria-hidden="true">
                #
              </span>
              <span>
                <small>Call our team</small>
                <strong>(708) 840-1141</strong>
              </span>
              <span className="contact-method-arrow" aria-hidden="true">
                &rarr;
              </span>
            </a>

            <div className="contact-panel-footer">
              <span>Philadelphia, PA</span>
              <span>Mon–Fri · 9 AM–6 PM ET</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
